import React, {useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import IntlMessage from "../../../../components/IntlMessage/IntlMessage";
import {Button, Flex, Tabs} from "antd";
import {DownloadOutlined} from "@ant-design/icons";
import MyText from "../../../../components/UI/Text/MyText";
import CreateUsers from "./Creation/CreateUsers";
import TeachersList from "./List/TeachersList";
import StudentsList from "./List/StudentsList";
import {getAllTeachersPageable} from "../../../../store/slices/TeachersListSlice";
import {getAllStudentsPageable} from "../../../../store/slices/StudentsListSlice";
import {getAllMEditorsPageable} from "../../../../store/slices/MEditorsListSlice";
import MEditorsList from "./List/MEditorsList";
import ExportPeopleModal from "../Groups/List/ExportPeopleModal";


const UsersPage = () => {
    const dispatch = useDispatch();
    const teachers = useSelector(state => state.teachersListTableController);
    const students = useSelector(state => state.studentsListTableController);
    const mEditors = useSelector(state => state.mEditorsListTableController);

    const [activeTab, setActiveTab] = useState('1');
    const [exportOpen, setExportOpen] = useState(false);

    // Роли для выгрузки подставляем по открытой вкладке, чтобы не переставлять галочки руками.
    const exportRoles = activeTab === '1'
        ? ['TEACHERS']
        : activeTab === '2'
            ? ['STUDENTS']
            : ['STUDENTS', 'TEACHERS'];

    const onChangeTabs = async (key) => {
        setActiveTab(key);
        if (key === '1') {
            dispatch(getAllTeachersPageable({
                page: teachers?.currentPage,
                limit: teachers?.pageSize,
                isGroupsNeeded: true
            }));
        }
        if (key === '2') {
            dispatch(getAllStudentsPageable({
                page: students?.currentPage,
                limit: students?.pageSize,
                isGroupsNeeded: true
            }));
        }
        if (key === '3') {
            dispatch(getAllMEditorsPageable({
                page: mEditors?.currentPage,
                limit: mEditors?.pageSize
            }));
        }
    };

    const tabItems = [
        {
            key: '1',
            label: <IntlMessage id={'teachersList'}/>,
            children: <TeachersList/>,
        },
        {
            key: '2',
            label: <IntlMessage id={'studentsList'}/>,
            children: <StudentsList/>,
        },
        {
            key: '3',
            label: <IntlMessage id={'mEditorsList'}/>,
            children: <MEditorsList/>,
        },
        {
            key: '4',
            label: <IntlMessage id={'create'}/>,
            children: <CreateUsers/>,
        },
    ]

    return (
        <Flex style={{width: "100%"}} align={"flex-start"} justify={"flex-start"} vertical gap={20}>
            <Flex justify={"space-between"} align={"center"} wrap={"wrap"} style={{width: "100%"}}>
                <MyText uppercase strong size={"large"}><IntlMessage id={'users'}/></MyText>
                <Button type="primary" icon={<DownloadOutlined/>} onClick={() => setExportOpen(true)}>
                    <span><IntlMessage id={'groups.exportPeople'}/></span>
                </Button>
            </Flex>
            <Tabs style={{width: "100%"}} defaultActiveKey={"1"} type="card" items={tabItems} onChange={onChangeTabs}/>

            {/* Страница «Пользователи» не привязана к статусу групп, поэтому по умолчанию берём всё:
                все группы и тех, кто вообще ни в одной группе не состоит. Иначе кнопка на странице
                «все пользователи» молча выгружала бы только активные группы. */}
            <ExportPeopleModal
                open={exportOpen}
                onClose={() => setExportOpen(false)}
                defaultRoles={exportRoles}
                defaultStatus={'ALL'}
                defaultIncludeWithoutGroups={true}
            />
        </Flex>
    );
};

export default UsersPage;